export function onScroll(element) {
  // calculate scroll down
  let scrollTop = element.scrollTop;
  let scrollHeight = element.scrollHeight;
  let offsetHeight = element.offsetHeight;

  let scrolledToBottom =
    Math.ceil(scrollTop + offsetHeight + 250) >= scrollHeight;
  return scrolledToBottom;
}
